<template>
  <div class="qui-somme-nous">
    <div class="intro">
      <div class="w-50">
        <img class="w-100" src="/images/quiSommeNous/qui-somme-nous-1.jpg" />
      </div>
      <div class="textIntro w-50">
        <div class="title">Qui sommes-nous ?</div>
        <div class="bodyText">
          <p>
            AUTOCOLOR service est une entreprise familiale spécialisée dans la peinture liquide, l’outillage et les consommables, fondée en 1986 par M. et Mme Sabourin.
            Leur fils Antoine, aujourd’hui Président, veut entretenir la convivialité et le service qui a toujours été au cœur de notre engagement.
          </p>
          <p>
            Située à Fontaine-Le-Comte, dans le département de la Vienne (86), nous accueillons professionnels et particuliers dans notre magasin de 600m² et visitons l’ensemble des professionnels du secteur de la peinture liquide de la Vienne (86), et des Deux-Sèvres (79). Notre zone de couverture s’étend de Poitiers à Loudun, en passant par Dangé St Romain, Châtellerault, Chauvigny, Montmorillon, l’Isle Jourdain, Melle, Civray, Niort, Parthenay, Bressuire et toutes les villes limitrophes, ainsi que jusqu’à Matha (17).
          </p>
          <p>
            Fort de cette expérience de plusieurs décennies, nous proposons à notre clientèle plus de 3500 références stockées (ainsi que des milliers d’autres sur commande) répartis en 4 grandes familles: AUTOMOBILE, INDUSTRIE, BATIMENT et BOIS.
          </p>
        </div>
      </div>
    </div>
    <div class="engagement">
      <img class="engagementBgImg" src="/images/quiSommeNous/bg-mask.png" alt="">
      <div class="title">Nos engagements</div>
      <div class="body">
        <div class="iconItem">
          <div class="icone">
            <img src="/images/quiSommeNous/icon-engagement-1.png" alt="">
          </div>
          <div class="text">
            Solutions techniques appropriées
          </div>
        </div>
        <div class="iconItem">
          <div class="icone">
            <img src="/images/quiSommeNous/icon-engagement-2.png" alt="">
          </div>
          <div class="text">
            Technologies les plus récentes
          </div>
        </div>
        <div class="iconItem">
          <div class="icone">
            <img src="/images/quiSommeNous/icon-engagement-3.png" alt="">
          </div>
          <div class="text">
            Approche personnalisée
          </div>
        </div>
      </div>
    </div>
    <div class="atouts">
      <div class="text">
        <div class="title">Nos atouts</div>
        <div class="listAtout">
          <ul>
            <li>
              <img src="/images/quiSommeNous/icone/bolt.png" alt="">
              Réactivité sur vos demandes et sur l’assistance
            </li>
            <li>
              <img src="/images/quiSommeNous/icone/paint-roller.png" alt="">
              Service de peinture sur mesure
            </li>
            <li>
              <img src="/images/quiSommeNous/icone/store.png" alt="">
              Connaissance des marchés
            </li>
            <li>
              <img src="/images/quiSommeNous/icone/palette.png" alt="">
              Expérience dans tous les secteurs d’application de peinture liquide
            </li>
            <li>
              <img src="/images/quiSommeNous/icone/people-group.png" alt="">
              Souplesse d’une entreprise familiale à taille humaine
            </li>
          </ul>
        </div>
      </div>
      <div class="imgAtout">
        <img src="/images/quiSommeNous/img-atout.png" alt="">
      </div>
    </div>
    <div class="champsApplication">
      <div class="title">Nos champs d'application</div>
      <div class="listChamps">
        <ul>
          <li v-for="atout1 in listChamp1">{{ atout1 }}</li>
        </ul>
        <ul>
          <li v-for="atout2 in listChamp2">{{ atout2 }}</li>
        </ul>
        <ul>
          <li v-for="atout3 in listChamp3">{{ atout3 }}</li>
        </ul>
      </div>
    </div>
    <div class="aag">
      <img class="bgAag" src="/images/quiSommeNous/bgAag.png" alt="">
      <div class="text">
        <div class="title">Le groupement AAG</div>
        <div class="describe">
          <p>
            Adhérent du groupe AAG (Alliance Automotive Group) sous la bannière COLOR SERVICE depuis 2018, nous sommes en mesure d’offrir une offre complète, Peinture – Pièces Neuves et Pièces de Réemploi et la force du Leader mondial de la pièce automobile GPC (Genuine Parts Company) sous la marque NAPA. Un groupe d’envergure internationale qui cultive une forte culture locale.
          </p>
        </div>
      </div>
      <div class="logoAag">
        <div class="autocolor">
          <img src="/images/autocolor-logo/autocolor-logo.png" />
        </div>
        <div class="partenaire">
          <img src="/images/quiSommeNous/groupauto-color-services-logo.png" />
          <img src="/images/quiSommeNous/napa-logo.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const listChamp1 = [
    'Brosserie',
    'Débosselage, Redressage et tirage',
    'Décapage et meulage',
    'Mastics et résine polyesters',
    'Outils de coupe',
    'Plaques d’immatriculation',
    'Réparation des optiques',
    'Réparation des pare-brises',
    'Réparation plastique',
    'Sablage',
    'Soudure',
    'Abrasifs'
]
const listChamp2 = [
    'Adhésifs techniques et ruban de masquage',
    'Essuyage',
    'Masquage et emballage',
    'Insonorisants et antigravillon',
    'Filtration peinture et filtration cabine de peinture',
    'Aérosols et stylos de retouche',
    'Peinture carrosserie',
    'Diluants et dégraissants',
    'Produits de lavage et nettoyage',
    'Lustrage et polissage',
    'Equipements de protection (EPI)',
]
const listChamp3 = [
    'Matériel pneumatique',
    'Matériel électrique',
    'Mobilier d’atelier',
    'Equipement d’atelier',
    'Outillage manuel',
    'Impression acrylique bâtiment',
    'Peinture acrylique bâtiment',
    'Peinture glycéro bâtiment',
    'Peinture décorative à effets',
    'Enduit de ratissage',
    'Protections sols et meubles',
    'Vernis bois et peinture bois'
]
</script>

<style scoped>
.qui-somme-nous {
  padding-top: 18%;
}

.intro {
  display: flex;
  column-gap: 3rem;
  padding-bottom: 6%;
  margin-right: 8rem;
}

.textIntro {
  font-family: Barlow, sans-serif;
}

.textIntro .title {
  font-size: 50px;
  text-transform: uppercase;
  margin-bottom: 1rem;
  text-shadow: 0 15px 6px #00000029;
}

.bodyText {
  font-size: 24px;
}

.engagement {
  position: relative;
  margin-bottom: 5rem;
  padding: 7rem 0;
  font-family: Barlow, sans-serif;
}

.engagement .title {
  text-align: center;
  font-size: 50px;
  text-transform: uppercase;
  margin-bottom: 1rem;
  text-shadow: 0 15px 6px #00000029;
}

.engagement .body {
  display: flex;
  margin-top: 3rem;
  justify-content: center;
  column-gap: 4rem;
}

.engagement .engagementBgImg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.iconItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 2rem;
}

.iconItem .text {
  font-size: 24px;
  text-transform: uppercase;
  width: 80%;
  text-align: center;
}

.atouts {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5rem;
}

.atouts .text .listAtout ul {
  list-style-type: none;
  padding: 0;
}

.atouts .text .listAtout ul li {
  padding: 1rem 0;
  display: flex;
  align-items: center;
  column-gap: 2rem;
  font-size: 24px;
  font-family: Barlow, sans-serif;
}

.atouts .text .title {
  font-size: 50px;
  text-transform: uppercase;
  margin-bottom: 1rem;
  text-shadow: 0 15px 6px #00000029;
  font-family: Barlow, sans-serif;
}

.atouts .text {
  margin: auto;
}

.champsApplication {
  background-color: #EEF3F8;
  padding: 2rem;
}

.champsApplication .title {
  font-size: 50px;
  text-transform: uppercase;
  margin-bottom: 1rem;
  text-shadow: 0 15px 6px #00000029;
  font-family: Barlow, sans-serif;
  text-align: center;
}

.champsApplication .listChamps {
  display: flex;
  justify-content: center;
  column-gap: 4rem;
  padding: 3rem 0;
}

.champsApplication .listChamps ul li {
  font-size: 24px;
  font-family: Barlow, sans-serif;
}

.aag {
  position: relative;
  display: flex;
  justify-content: space-around;
}

.aag .text {
  color: #fff;
  margin: auto;
  width: 70%;
}

.aag .text .title {
  font-size: 50px;
  text-transform: uppercase;
  text-shadow: 0 15px 6px #00000029;
  font-family: Barlow, sans-serif;
  margin: 10rem 0 1rem 10rem ;
}

.aag .text .describe {
  font-size: 24px;
  font-family: Barlow, sans-serif;
  margin: 1rem 10rem 10rem 10rem;
}

.aag .logoAag {
  width: 30%;
  margin: auto;
}
.aag .logoAag .partenaire {
  display: flex;
  align-items: center;
  column-gap: 2rem;
}

.aag .bgAag {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -1;
}

.w-100 {
  width: 100% !important;
}

.w-50 {
  width: 50% !important;
}
</style>